function stripPrefix(str) {
    for (let prefix of ['/cs/', '/en/', '/']) {
        if (str.startsWith(prefix)) {
            return str.slice(prefix.length);
        }
    }
    
    return str;
}


window.addEventListener('message', (event) => {
    if (event.data.type !== 'AdminHelpIframeLoaded') {
        return;
    }

    console.log('Admin:', event, event.origin, window.location.pathname);


    const friendlyUrl = stripPrefix(window.location.pathname);

    if (event.data.friendlyUrl === friendlyUrl) {
        return;
    }

    window.top.postMessage({
        type: 'DocsFriendlyUrlUpdate',
        friendlyUrl: friendlyUrl
    }, event.origin);
});

